import React, { useEffect } from 'react';
import { translate } from 'translations/i18n';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import styled from 'styled-components';

import useCompanyTemplates from '../hooks/useCompanyTemplates';

import TemplatesList from './TemplatesList';

import EmptyStateContainer from 'components/projects/taskList/components/EmptyStateContainer';

const SectionHeader = styled.p`
  color: var(--cc_color_text_nonessential);
  font-weight: 500;
  font-size: var(--cc_size_text_s);
  line-height: 20px;
  margin-inline-start: var(--cc_size_spacing_l);
`;
const TemplatesContainer = styled.div`
  margin-block-start: var(--cc_size_spacing_l);
`;

const RecentContainer = styled.div`
  margin-block-end: var(--cc_size_spacing_l);
`;

const CompanyTemplates = ({ includeAllTemplates, recentTemplates }) => {
  const { companyTemplates, loading, error, hasNextPage, fetchNextPage } =
    useCompanyTemplates(includeAllTemplates);
  const [ref, inView] = useInView({
    threshold: 0,
    rootMargin: '0px 0px 300px 0px', // do not remove 'px' from 0 values
  });

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);
  return (
    <>
      {companyTemplates.length > 0 ? (
        <TemplatesContainer>
          {includeAllTemplates && recentTemplates.length ? (
            <RecentContainer>
              <SectionHeader>
                {translate('projects.taskList.templates.recent')}
              </SectionHeader>
              <TemplatesList templates={recentTemplates} />
            </RecentContainer>
          ) : null}
          {includeAllTemplates ? (
            <SectionHeader>
              {translate('projects.taskList.templates.all')}
            </SectionHeader>
          ) : null}
          <TemplatesList
            templates={companyTemplates}
            loading={loading}
            error={error}
          />
        </TemplatesContainer>
      ) : (
        <EmptyStateContainer error={error} loading={loading} />
      )}
      <div ref={ref} style={{ height: 4 }} />
    </>
  );
};

CompanyTemplates.defaultProps = {
  recentTemplates: [],
};

CompanyTemplates.propTypes = {
  includeAllTemplates: PropTypes.bool.isRequired,
  recentTemplates: PropTypes.arrayOf(PropTypes.object),
};

export default CompanyTemplates;
